import { Component, lazy, Suspense, useEffect, useMemo, useState, type ReactNode } from "react";
import { Maximize2, Network } from "lucide-react";
import { Modal } from "./Modal";
import type { AgentFlowProps } from "./AgentFlowCanvas";

type Props = Omit<AgentFlowProps, "onClose">;
class CanvasBoundary extends Component<{ children: ReactNode; onClose: () => void }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <Modal open title="流程画布暂时无法打开" onClose={this.props.onClose} footer={<button type="button" className="button button-secondary" onClick={this.props.onClose}>关闭并返回创作</button>}><p>画布资源未能加载或渲染。当前正文与生成任务不受影响，请关闭后重新打开。</p></Modal>;
    return this.props.children;
  }
}
/** The graph bundle is only loaded on demand; failure never takes down the editor. */
export function AgentFlowLauncher(props: Props) {
  const [open, setOpen] = useState(false);
  const Canvas = useMemo(() => lazy(() => import("./AgentFlowCanvas")), [open]);
  useEffect(() => setOpen(false), [props.projectId]);
  return <>
    <button type="button" className="af-launcher" aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}>
      <Network size={21} /><span><strong>打开 Agent 流程画布</strong><small>节点关系 · 条件分支 · 执行详情</small></span><Maximize2 size={15} />
    </button>
    {open && <CanvasBoundary onClose={() => setOpen(false)}><Suspense fallback={<Modal open title="正在打开流程画布" onClose={() => setOpen(false)}><p>正在载入节点视图，正文与生成任务保持原状。</p></Modal>}><Canvas key={`${props.projectId}:${props.run?.id ?? "preview"}`} {...props} onClose={() => setOpen(false)} /></Suspense></CanvasBoundary>}
  </>;
}
